import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort, Calculator } from 'react-bootstrap-icons';

import Btn from '../../components/framework/buttons/btn';
import useTranslation from '../../hooks/use_translation';

const CalculatorsList = () => {
	const { t } = useTranslation('component_calculators_list');

	return (
		<div className="row">
			<div className={`col-lg-4 pe-lg-0 mb-lg-2 mb-1`}>
				<Btn
					className="clickable py-3"
					color="light"
					component="link"
					fullWidth
					labelType="h3"
					leftSection={<Calculator className="text-primary" />}
					removePill
					rightSection={<ArrowRightShort className="thumb-sm" />}
					size="md"
					to="/kalkylatorer/fritt-testosteron"
					variant="thumb_btn"
					withThumb
				>
					{t('t1')}
				</Btn>
			</div>
			<div className={`col-lg-4 pe-lg-0 mb-lg-2 mb-1`}>
				<Btn
					className="clickable py-3"
					color="light"
					component="link"
					fullWidth
					labelType="h3"
					leftSection={<Calculator className="text-primary" />}
					removePill
					rightSection={<ArrowRightShort className="thumb-sm" />}
					size="md"
					to="/kalkylatorer/bmi"
					variant="thumb_btn"
					withThumb
				>
					{t('t2')}
				</Btn>
			</div>
			<div className={`col-lg-4 pe-lg-0 mb-lg-2 mb-1`}>
				<Btn
					className="clickable py-3"
					color="light"
					component="link"
					fullWidth
					labelType="h3"
					leftSection={<Calculator className="text-primary" />}
					removePill
					rightSection={<ArrowRightShort className="thumb-sm" />}
					size="md"
					to="/kalkylatorer/progesteron-ostrogen-ratio"
					variant="thumb_btn"
					withThumb
				>
					{t('t3')}
				</Btn>
			</div>
			<div className={`col-lg-4 pe-lg-0 mb-lg-2 mb-1`}>
				<Btn
					className="clickable py-3"
					color="light"
					component="link"
					fullWidth
					labelType="h3"
					leftSection={<Calculator className="text-primary" />}
					removePill
					rightSection={<ArrowRightShort className="thumb-sm" />}
					size="md"
					to="/kalkylatorer/agglossning"
					variant="thumb_btn"
					withThumb
				>
					{t('t4')}
				</Btn>
			</div>
		</div>
	);
};

CalculatorsList.propTypes = {
	location: PropTypes.object,
};

export default CalculatorsList;
